export default "__VITE_ASSET__CVnHxT_m__"